module.exports = " <div class=wrap> <h2 v-html=\"c('strapLine')\"></h2> <p><a href=mailto:hello@curiousconce.pt class=button v-html=\"c('contactButton')\"></a></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 8
// module chunks = 0